import { render, staticRenderFns } from "./ui_button.vue?vue&type=template&id=0c54a5e1&scoped=true&"
import script from "./ui_button.vue?vue&type=script&lang=js&"
export * from "./ui_button.vue?vue&type=script&lang=js&"
import style0 from "./ui_button.vue?vue&type=style&index=0&id=0c54a5e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c54a5e1",
  null
  
)

export default component.exports